import { Inject, Injectable } from '@angular/core';
import type { TypedAction } from '@freelancer/datastore/core';
import {
  FREELANCER_HTTP_CONFIG,
  FreelancerHttpConfig,
} from '@freelancer/freelancer-http';
import { isDefined } from '@freelancer/utils';
import { Actions, createEffect } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';

@Injectable()
// This allows the action to dispatch another one with the baseUrl added to the result, so we can add this
// to the users documents
export class UsersEffect {
  readonly effect$ = createEffect(() =>
    this.actions$.pipe(
      filter(
        action =>
          action.type === 'API_FETCH_SUCCESS' &&
          action.payload.type === 'users' &&
          // Ensure that we are filtering only initial dispatch to avoid an infinite loop
          !isDefined(action.payload.result.baseUrl),
      ),
      map(action => {
        return {
          ...action,
          payload: {
            ...action.payload,
            result: {
              ...action.payload.result,
              baseUrl: this.freelancerHttpConfig.baseUrl,
            },
          },
        };
      }),
    ),
  );

  constructor(
    private actions$: Actions<TypedAction>,
    @Inject(FREELANCER_HTTP_CONFIG)
    private freelancerHttpConfig: FreelancerHttpConfig,
  ) {}
}
